import { render } from "./RelatedMessages.vue?vue&type=template&id=2a4653ce&ts=true"
import script from "./RelatedMessages.vue?vue&type=script&lang=ts"
export * from "./RelatedMessages.vue?vue&type=script&lang=ts"

const cssModules = {}
import style0 from "./RelatedMessages.vue?vue&type=style&index=0&id=2a4653ce&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__